export default __webpack_public_path__ + "static/media/event-graphic.cca95391.png";